// extracted by mini-css-extract-plugin
module.exports = {"collapse-panel-header":"style_collapse-panel-header___qP8_","collapse-panel-header__icon":"style_collapse-panel-header__icon__epiS0"};